export default __webpack_public_path__ + "static/media/plant_based_topic.4acea768.jpg";